import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface RoleListCustomerHeaderProps
  extends HeaderContext<GatewayRoleModel, GatewayRoleModel['customer']> {}

export const RoleListCustomerHeader = (): // props: RoleListCustomerHeaderProps,
ReactNode => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return t('delmonicos-shared-sdk.outputs-gateway-role.customer');
};
